import React, { useState, useEffect } from "react";
import styled from "styled-components";

// 커스텀 드롭다운 스타일
const CustomDropdown = styled.div`
  position: relative;
  flex-grow: 1;
  color: #fff;
`;

const DropdownButton = styled.button`
  width: 100%;
  height: 42px;
  border-radius: 8px;
  border: 2px solid
    ${(props) => props.$selectedColor || "rgba(255, 255, 255, 0.3)"};
  background: rgba(44, 44, 44, 0.7);
  color: #fff;
  padding: 0 12px;
  outline: none;
  transition: all 0.2s ease;
  font-size: 14px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:focus {
    border-color: #4caf50;
    box-shadow: 0 0 0 3px rgba(76, 175, 80, 0.25);
  }
`;

const DropdownList = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: rgba(44, 44, 44, 0.95);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  margin-top: 4px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  backdrop-filter: blur(10px);
`;

const DropdownItem = styled.div`
  padding: 12px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: background-color 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  &:first-child {
    border-radius: 8px 8px 0 0;
  }

  &:last-child {
    border-radius: 0 0 8px 8px;
  }
`;

const ColorIndicator = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 4px;
  background-color: ${(props) => props.$color || "#fff"};
  border: 1px solid rgba(255, 255, 255, 0.3);
`;

export default function ColorSelectDropdown({
  options = [],
  selectedValue,
  onSelect,
  placeholder = "옵션을 선택하세요",
  className = "custom-dropdown",
}) {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  // 드롭다운 외부 클릭 시 닫기
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isDropdownOpen && !event.target.closest(`.${className}`)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDropdownOpen, className]);

  // 선택된 옵션 찾기
  const selectedOption = options.find((option) => {
    const optionValue = option.id || option.modeId || option.value;

    return +optionValue === +selectedValue;
  });

  const handleOptionClick = (option) => {
    const value = option.id || option.modeId || option.value;
    onSelect(value);
    setIsDropdownOpen(false);
  };

  return (
    <CustomDropdown className={className}>
      <DropdownButton
        onClick={() => setIsDropdownOpen(!isDropdownOpen)}
        $selectedColor={
          selectedOption?.modeColor ||
          selectedOption?.color ||
          selectedOption?.typeColor
        }
      >
        <span>
          {selectedOption?.modeName ||
            selectedOption?.name ||
            selectedOption?.typeName ||
            placeholder}
        </span>
        <span>{isDropdownOpen ? "▲" : "▼"}</span>
      </DropdownButton>

      {isDropdownOpen && (
        <DropdownList>
          {options.map((option, index) => {
            const optionValue =
              option.id || option.modeId || option.value || option.id;
            const optionName =
              option.modeName || option.name || option.typeName;
            const optionColor =
              option.modeColor || option.color || option.typeColor;

            return (
              <DropdownItem
                key={optionValue || index}
                onClick={() => handleOptionClick(option)}
              >
                <ColorIndicator $color={optionColor} />
                <span>{optionName}</span>
              </DropdownItem>
            );
          })}
        </DropdownList>
      )}
    </CustomDropdown>
  );
}
